export default __webpack_public_path__ + "static/media/Active_Dashboard.12cd7e90.svg";